import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '@Services/apiAxios';

// -----------------------------
// Types
// -----------------------------
export interface ShipmentInvoiceReportState {
  loading: boolean;
  url: string | null;
  error: string | null;
}

const initialState: ShipmentInvoiceReportState = {
  loading: false,
  url: null,
  error: null,
};

// -----------------------------
// Async Thunk (API call inside slice)
// -----------------------------
export const getShipmentInvoiceReport = createAsyncThunk<{ url: string }, any, { rejectValue: string }>(
  'shipmentInvoiceReport/get',
  async (params, thunkAPI) => {
    try {
      const response = await API.get('/invoice/account/shipment_invoice_report', {
        params,
      });

      return response.data; // { url: string }
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message || 'Failed to fetch report');
    }
  },
);

// -----------------------------
// Slice
// -----------------------------
const shipmentInvoiceReportSlice = createSlice({
  name: 'shipmentInvoiceReport',
  initialState,
  reducers: {
    resetReportState: state => {
      state.loading = false;
      state.url = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getShipmentInvoiceReport.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getShipmentInvoiceReport.fulfilled, (state, action: PayloadAction<{ url: string }>) => {
        state.loading = false;
        state.url = action.payload.url;
      })
      .addCase(getShipmentInvoiceReport.rejected, (state, action) => {
        state.loading = false;
        state.url = null;
        state.error = (action.payload as string) || 'Something went wrong';
      });
  },
});

// -----------------------------
// Actions
// -----------------------------
export const { resetReportState } = shipmentInvoiceReportSlice.actions;

// -----------------------------
// Reducer
// -----------------------------
export default shipmentInvoiceReportSlice.reducer;
